import { useState } from "react";
import { Button, ButtonGroup, Grid } from "@mui/material";
import Templete from "../../template/Template";

export default function ContasReceber() {
    const [menuActive, setMenuActive] = useState("0");
    const [rows, setRows] = useState([]);

    return (
        <Templete menuActive="contas_receber">
            <Grid container spacing={1}>
                <Grid item xs={false} sm={3}>
                    <h1>RECEBER</h1>
                </Grid>
            </Grid>
        </Templete>
    );
}